import { useForwardPropsEmits as e } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { TooltipRoot_default as t } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipRoot.js";
import { createBlock as n, defineComponent as r, mergeProps as i, openBlock as a, renderSlot as o, unref as s, withCtx as c } from "vue";
//#region src/components/ui/tooltip/core/Tooltip.vue?vue&type=script&setup=true&lang.ts
var l = /* @__PURE__ */ r({
	__name: "Tooltip",
	props: {
		defaultOpen: { type: Boolean },
		open: { type: Boolean },
		delayDuration: {},
		disableHoverableContent: { type: Boolean },
		disableClosingTrigger: { type: Boolean },
		disabled: { type: Boolean },
		ignoreNonKeyboardFocus: { type: Boolean }
	},
	emits: ["update:open"],
	setup(r, { emit: l }) {
		let u = e(r, l);
		return (e, r) => (a(), n(s(t), i({
			"ignore-non-keyboard-focus": "",
			"data-slot": "tooltip"
		}, s(u)), {
			default: c(() => [o(e.$slots, "default")]),
			_: 3
		}, 16));
	}
});
//#endregion
export { l as default };

//# sourceMappingURL=Tooltip_vue.js.map